<template>
  <v-card elevation="3" class="cruise-card rounded-lg overflow-hidden">
    <!-- Image -->
    <v-img :src="cruise.imageUrl" height="180px" cover class="cruise-img" />

    <!-- Content -->
    <v-card-text class="pa-5">
      <div class="text-h5 font-weight-bold mb-4">
        {{ cruise.description }}
      </div>

      <!-- Cruise Info -->
      <v-row dense class="cruise-info text-h6	text-medium-emphasis">
        <v-col cols="6" class="d-flex align-center mb-2">
          <v-icon icon="fa-solid fa-calendar" size="18" class="me-2" />
          {{ cruise.dateOfSailing }}
        </v-col>
        <v-col cols="6" class="d-flex align-center mb-2">
          <v-icon icon="fa-solid fa-ship" size="18" class="me-2" />
          {{ cruise.ship }}
        </v-col>
        <v-col cols="6" class="d-flex align-center mb-2">
          <v-icon icon="fa-solid fa-anchor" size="18" class="me-2" />
          {{ cruise.port }}
        </v-col>
        <v-col cols="6" class="d-flex align-center mb-2">
          <v-icon icon="fa-solid fa-moon" size="18" class="me-2" />
          {{ cruise.numberOfNights }} Nights
        </v-col>
      </v-row>

      <!-- CTA Button -->
      <v-btn
        :href="cruise.link"
        color="primary"
        variant="flat"
        block
        class="mt-4 text-uppercase font-weight-bold"
        size="large"
      >
        Book Now
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CruiseCardHome',
  props: {
    cruise: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.cruise-img {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.cruise-info {
  line-height: 1.4;
}

.me-2 {
  margin-right: 8px;
}
</style>
